import { APIResponse, PaginatedAPIResponse } from "../models/NetworkResponse";
import { getAPI, postAPI } from "./Networking";
import { Messages } from "../models/Messages/Message";

export default class ChatAPI {
  getTaskMessages = async (params: {
    taskId: number;
    page?: number;
    limit?: number;
  }): Promise<PaginatedAPIResponse<Messages>> => {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) {
        queryParams.append("page_no", params.page.toString());
      }

      if (params.limit) {
        queryParams.append("limit", params.limit.toString());
      }

      const response = await getAPI(
        `/v5/tasks/task-id/${params.taskId}/messages?${queryParams.toString()}`
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getTaskMessagesAfterLastMessage = async (params: {
    taskId: number;
    page?: number;
    limit?: number;
    lastMessageId: number;
  }): Promise<Messages[]> => {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) {
        queryParams.append("page_no", params.page.toString());
      }

      if (params.limit) {
        queryParams.append("limit", params.limit.toString());
      }
      queryParams.append("last_message_id", params.lastMessageId.toString());

      const response = await getAPI(
        `/v5/tasks/task-id/${params.taskId}/messages?${queryParams.toString()}`
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  addMessage = async (params: {
    task_id: number;
    message: string;
  }): Promise<APIResponse> => {
    try {
      const response = await postAPI(
        `/v5/tasks/task-id/${params.task_id}/message`,
        {
          message: params.message,
        }
      );

      return response;
    } catch (error) {
      throw error;
    }
  };
}
